import { useState, useEffect } from "react";
import { BookletDetails } from "@/@types";
import { FallbackImage, ShareSocialMedia } from "../common";

type Props = {
  bookletDetails: BookletDetails;
};

export default function BookletDetailsCard({ bookletDetails }: Props) {
  const [currentUrl, setCurrentUrl] = useState("");  
  const { media, url } = bookletDetails;

  const rawPath = media === 'url' ? url : `/api/pdf/${url?.split('/uploads/')[1] ?? ''}`;
  const path = rawPath?.includes('/uploads/')
    ? `/api/pdf/${rawPath.split('/uploads/')[1] ?? ''}`
    : rawPath;

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  if (!bookletDetails) {
    return <p>No se encontraron detalles para esta literatura.</p>;
  }

  return (
    <div className="rounded-lg shadow-lg border border-gray-200">
      <div className="bg-white p-6">
        <div className="flex flex-col lg:flex-row gap-4 items-start">
          <div className="w-[200px] mx-auto lg:mx-0 aspect-[2/3]">
            <FallbackImage
              width={350}
              height={850}
              src={bookletDetails.image || "/images/img_no_found.jpg"}
              alt={bookletDetails.title || "Título no disponible"}
            />
          </div>

          <div className="lg:w-2/3 flex flex-col">
            <span className="bg-black text-white px-3 py-1 text-sm font-semibold rounded self-start">
              {bookletDetails.category.toUpperCase()}
            </span>

            <h1 className="text-3xl font-bold text-gray-800 mt-3 mb-1">
              {bookletDetails.title}
            </h1>

            <p className="text-gray-600 text-sm">{bookletDetails.date}</p>

            <p className="mt-4 text-gray-700">{bookletDetails.description}</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-between items-center">
        <div className="pl-4 hidden lg:block">
          {currentUrl && (
            <ShareSocialMedia
              shareUrl={currentUrl}
              containerClassName="flex gap-2 text-gray-500"
              textClassName="text-sm text-black uppercase font-bold"
              label="COMPARTIR EN"
            />
          )}
        </div>

        {bookletDetails.url && (
          <a
            href={`${path}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-yellow-400 text-black font-semibold px-6 py-3 rounded-md shadow-md hover:bg-yellow-500 mt-4 lg:mt-0"
          >
            DESCARGAR FOLLETO
          </a>
        )}
      </div>
      
      <div className="h-2 bg-yellow-400 w-full"></div>
      
      <div className="flex justify-center lg:hidden">
        {currentUrl && (
          <ShareSocialMedia
            shareUrl={currentUrl}
            containerClassName="flex gap-2 text-gray-500"
            textClassName="text-sm text-black uppercase font-bold pt-5"
            label="COMPARTIR EN"
          />
        )}
      </div>
    </div>
  );
}
